import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    itemText: {
        color: "black",
    
      },
      link:{
        textDecoration: 'none'
      }
}));

export default useStyles;
